export default __webpack_public_path__ + "static/media/12380-obolazul.21755208.pdf";